// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2Mt9A","info":"PatientInfo_info__2ttmS"};